import { FlowDurationUnits, FlowHieDocumentFormat } from 'flow-schema';

import { api } from 'common';

import { HieGetDocumentsFormFields } from './FormFields';
import { HieGetDocumentsBlockDocumentationMarkdown } from './documentation';
import type { BlockConfigProps } from '../../types';

export const hieGetDocumentsConfig: BlockConfigProps<
  api.FlowDefinition.HieGetDocuments.HieGetDocumentsBlock['config']
> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'hieGetDocuments',
  defaultConfig: {
    sourceBlock: {
      sourceBlockName: '',
    },
    resources: [],
    includeRelatedRecords: false,
    documentFormat: FlowHieDocumentFormat.ConsolidatedData,
    dateFrom: '',
    dateTo: '',
    timeout: {
      value: 10,
      units: FlowDurationUnits.Minutes,
    },
  },
  configFields: {
    schema: api.FlowDefinition.HieGetDocuments.HieGetDocumentsBlockConfigSchema,
    FormFields: HieGetDocumentsFormFields,
  },
  documentationMarkdown: HieGetDocumentsBlockDocumentationMarkdown,
};
